import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import AccessControlList from "./AccessControlList";
import AccessControlCreation from "./AccessControlCreation";
import AccessControlDetail from "./AccessControlDetail";

function AccessControl() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <AccessControlList />
      </Route>
      <Route exact path={`${path}/add`}>
        <AccessControlCreation />
      </Route>
      <Route exact path={`${path}/:domainId`}>
        <AccessControlDetail />
      </Route>
    </Switch>
  );
}

export default AccessControl;
